type ProfferLogoMarkProps = {
  className?: string
  rounded?: '2xl' | 'xl' | 'app' | 'full'
}

const roundedClass: Record<NonNullable<ProfferLogoMarkProps['rounded']>, string> = {
  '2xl': 'rounded-2xl',
  xl: 'rounded-xl',
  app: 'rounded-app',
  full: 'rounded-full',
}

export function ProfferLogoMark({
  className = 'h-10 w-10 sm:h-11 sm:w-11',
  rounded = '2xl',
}: ProfferLogoMarkProps) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/icon.png`}
      alt=""
      aria-hidden
      className={`shrink-0 object-cover shadow-brand-soft ring-1 ring-white/20 dark:ring-zinc-700/50 ${roundedClass[rounded]} ${className}`}
    />
  )
}
